import { css as v, LitElement as b, nothing as c, html as d } from "lit";
import { property as l, customElement as m } from "lit/decorators.js";
import { b as y } from "./styles-scZ6dVz-.js";
import { b as s, a as h } from "./events-CkEPl0SM.js";
import "./ark-input-DLb_kkBs.js";
import "./ark-button-DYI_xPdn.js";
import "./ark-icon-TW_tZfDu.js";
var f = Object.defineProperty, g = Object.getOwnPropertyDescriptor, a = (t, r, p, o) => {
  for (var i = o > 1 ? void 0 : o ? g(r, p) : r, n = t.length - 1, u; n >= 0; n--)
    (u = t[n]) && (i = (o ? u(r, p, i) : u(i)) || i);
  return o && i && f(r, p, i), i;
};
let e = class extends b {
  constructor() {
    super(...arguments), this.value = "", this.placeholder = "Search...", this.size = "md", this.type = "search", this.disabled = !1, this.clearable = !0, this.ariaLabel = null;
  }
  handleInput(t) {
    this.value = t.detail?.value ?? "", s(this, h.INPUT, { value: this.value });
  }
  handleChange(t) {
    this.value = t.detail?.value ?? "", s(this, h.CHANGE, { value: this.value });
  }
  handleClear() {
    this.value = "", s(this, h.CLEAR, { value: this.value }), s(this, h.INPUT, { value: this.value }), s(this, h.CHANGE, { value: this.value });
  }
  render() {
    const t = this.ariaLabel ?? this.placeholder ?? "Search", r = this.size === "lg" ? "md" : this.size;
    return d`
      <div part="field" class="field">
        <ark-input
          .value=${this.value}
          placeholder=${this.placeholder ?? c}
          size=${this.size}
          type=${this.type}
          ?disabled=${this.disabled}
          aria-label=${t}
          @ark-input=${this.handleInput}
          @ark-change=${this.handleChange}
        >
          <ark-icon slot="prefix" name="search" size="sm"></ark-icon>
          ${this.clearable && this.value ? d`
                <ark-button
                  slot="suffix"
                  class="clear-button"
                  variant="ghost"
                  size=${r}
                  icon-only
                  label="Clear search"
                  @click=${this.handleClear}
                >
                  <ark-icon name="x" size="sm"></ark-icon>
                </ark-button>
              ` : c}
        </ark-input>
      </div>
    `;
  }
};
e.styles = [
  y,
  v`
      :host {
        display: block;
      }

      .field {
        width: 100%;
      }

      .clear-button::part(button) {
        padding: 0;
        min-width: auto;
        height: auto;
      }
    `
];
a([
  l({ type: String })
], e.prototype, "value", 2);
a([
  l({ type: String })
], e.prototype, "placeholder", 2);
a([
  l({ type: String })
], e.prototype, "size", 2);
a([
  l({ type: String })
], e.prototype, "type", 2);
a([
  l({ type: Boolean })
], e.prototype, "disabled", 2);
a([
  l({ type: Boolean, attribute: "clearable" })
], e.prototype, "clearable", 2);
a([
  l({ type: String, attribute: "aria-label" })
], e.prototype, "ariaLabel", 2);
e = a([
  m("ark-search-field")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-search-field-CRniYIeN.js.map
